import axios from '@dap/shared-utils/http.js';

export default {
    // 获取头条推荐创意列表
    getRecommendedCreativeList (params = {}) {
        return axios.get('/dapper/api/toutiao_ad/recommend/creatives', {
            params,
        });
    },

    getCreativeList (params = {}) {
        return axios.get('/dapper/api/creative', { params });
    },

    // 开启/暂停创意
    updateCreativeStatus (params = {}) {
        return axios.put('/dapper/api/creative', params);
    },

    deleteCreative (params = {}) {
        return axios.delete('/dapper/api/creative', { data: params });
    },

    getCreativeInfo (params = {}) {
        return axios.get('/dapper/api/creative/detail', { params });
    },

    // 获取动态词包列表
    getWordList (params = {}) {
        return axios.get('/dapper/api/creative/word', { params });
    },

    // 获取标题库列表
    getTitleList (params = {}) {
        return axios.get('/dapper/api/creative/title', { params });
    },

    // 获取素材库列表
    getMaterialList (params = {}) {
        return axios.get('/dapper/api/creative/materials', { params });
    },

    // 获取视频封面列表
    getCoverImageList (params = {}) {
        return axios.get('/dapper/api/creative/video_cover', { params });
        // return axios.get('/dapper/api/creative/main/video_cover', { params });
    },

    // 获取创意类型列表
    getImageModeList (params = {}) {
        return axios.get('/dapper/api/creative/add/selector', { params });
    },

    // 保存创意
    saveCreative (params = {}) {
        return axios.post('/dapper/api/creative', params);
    },

    getRadioList (params) {
        return axios.get('/dapper/api/creative/title', { params });
    },

    //编辑创意
    getDetail (params) {
        return axios.get('/dapper/api/creative/detail', { params });
    },

    enableCreative (params = {}) {
        return axios.put('/dapper/api/creative', params);
    },

    getCreativeSelector (params = {}) {
        return axios.get('/dapper/api/creative/selector', { params });
    },

    getGdtImgMaterialList (params = {}) {
        return axios.get('/dapper/api/creative/gdt/image', { params });
    },

    getGdtVedioMaterialList (params = {}) {
        return axios.get('/dapper/api/creative/gdt/video', { params });
    },

    getGdtVideoCoverList (params = {}) {
        return axios.get('/dapper/api/creative/gdt/video_cover', { params });
    },
    // 品牌
    saveBrand (params = {}) {
        return axios.post('/dapper/api/creative/gdt/brand_save', params);
    },

    getBrandList (params = {}) {
        return axios.get('/dapper/api/creative/gdt/brand', { params });
    },

    getGdtTitle (params = {}) {
        return axios.get('/dapper/api/creative/gdt/title', { params });
    },

    deleteGdtTitle (params = {}) {
        return axios.delete('/dapper/api/creative/gdt/title', { data: params });
    },
    createGdtCreative (params = {}) {
        if (params.creative_id) {
            return axios.put('/dapper/api/creative/gdt', params);
        }
        return axios.post('/dapper/api/creative/gdt', params);
    },

    getGdtCreativeList (params = {}) {
        return axios.get('/dapper/api/creative/gdt', { params });
    },

    deleteGdtCreative (params = {}) {
        return axios.delete('/dapper/api/creative/gdt', { data: params });
    },

    updateGdtCreativeStatus (params = {}) {
        return axios.put('/dapper/api/creative/gdt/status', params);
    },

    gdtCreativeDetail (params = {}) {
        return axios.get('/dapper/api/creative/detail/gdt', { params });
    },

    getAuthorList (params = {}) {
        return axios.get('/dapper/api/creative/user', { params });
    },
};
